// ONYX – Sticky-Bar aus dem Section-Wrapper an den body hängen (Fix für fixed-in-transform)
(function () {
  const bar = document.getElementById('sticky-cart-bar');
  if (bar && bar.parentElement !== document.body) {
    document.body.appendChild(bar);
  }
})();


// ONYX – globale Scroll-Reveal-Animationen
(function () {
  function initReveals() {
    const els = document.querySelectorAll(
      '.reveal, .reveal-left, .reveal-right, .reveal-scale'
    );

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach((el) => el.classList.add('active'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    els.forEach((el) => observer.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveals);
  } else {
    initReveals();
  }
})();

// ONYX – Count-up Animation für Specs
(function () {
  function animateCount(el) {
    const target = parseFloat(el.dataset.target);
    const isDecimal = el.dataset.target.includes('.');
    const duration = 1500;
    const start = performance.now();

    function tick(now) {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = target * eased;
      el.textContent = isDecimal ? current.toFixed(1) : Math.round(current);
      if (progress < 1) requestAnimationFrame(tick);
      else el.textContent = el.dataset.target;
    }
    requestAnimationFrame(tick);
  }

  const nums = document.querySelectorAll('.spec-number');
  if (!nums.length) return;

  const obs = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        animateCount(entry.target);
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  nums.forEach((n) => obs.observe(n));
})();

// ONYX – FAQ Accordion
(function () {
  document.querySelectorAll('.faq-question').forEach((btn) => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const isOpen = item.classList.contains('active');

      document.querySelectorAll('.faq-item').forEach((i) => {
        i.classList.remove('active');
        i.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        item.classList.add('active');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
})();

// ONYX – Custom Cursor (Desktop only)
(function () {
  if (window.matchMedia('(max-width: 768px)').matches) return;

  const ring = document.createElement('div');
  ring.className = 'cursor';
  const dot = document.createElement('div');
  dot.className = 'cursor-dot';
  document.body.appendChild(ring);
  document.body.appendChild(dot);

  let mouseX = 0, mouseY = 0, ringX = 0, ringY = 0;

  document.addEventListener('mousemove', (e) => {
    mouseX = e.clientX; mouseY = e.clientY;
    dot.style.left = mouseX + 'px';
    dot.style.top = mouseY + 'px';
  });

  function animate() {
    ringX += (mouseX - ringX) * 0.15;
    ringY += (mouseY - ringY) * 0.15;
    ring.style.left = ringX + 'px';
    ring.style.top = ringY + 'px';
    requestAnimationFrame(animate);
  }
  animate();

  document.querySelectorAll('a, button, .variant-option').forEach((el) => {
    el.addEventListener('mouseenter', () => ring.classList.add('hover'));
    el.addEventListener('mouseleave', () => ring.classList.remove('hover'));
  });
})();

// ONYX – Preloader (1x pro Session)
(function () {
  const pre = document.getElementById('preloader');
  if (!pre) return;
  if (sessionStorage.getItem('onyx_loaded')) { pre.remove(); return; }

  const bar = document.getElementById('preloader-progress');
  let p = 0;
  const timer = setInterval(() => {
    p += Math.random() * 30;
    if (p >= 100) {
      p = 100;
      clearInterval(timer);
      setTimeout(() => {
        pre.classList.add('hidden');
        sessionStorage.setItem('onyx_loaded', '1');
        setTimeout(() => pre.remove(), 600);
      }, 200);
    }
    bar.style.width = p + '%';
  }, 150);
})();

// ONYX – Sticky Cart Bar + Varianten-Sync + Cart + Free-Ship
(function () {
  const bar = document.getElementById('sticky-cart-bar');
  const product = document.getElementById('product');

  if (bar && product) {
    let inView = false;
    new IntersectionObserver((e) => { inView = e[0].isIntersecting; }, { threshold: 0.3 }).observe(product);
    window.addEventListener('scroll', () => {
      bar.classList.toggle('show', window.scrollY > 800 && !inView);
    }, { passive: true });

    const chips     = bar.querySelectorAll('.sticky-variant-chip');
    const priceEl   = bar.querySelector('.sticky-cart-price');
    const qInfo     = bar.querySelector('[data-scb-quickinfo]');
    const buyBtn    = document.getElementById('sticky-cart-btn');
    const buyLabel  = buyBtn && buyBtn.querySelector('.scb-btn-label');
    const defLabel  = buyLabel ? buyLabel.textContent : 'Add to Setup';
    const cartBadge = document.getElementById('scb-cart-badge');
    const shipWrap  = bar.querySelector('[data-scb-freeship]');
    const shipFill  = bar.querySelector('[data-scb-fill]');
    const shipLabel = bar.querySelector('[data-scb-shiplabel]');
    const threshold = parseInt(bar.dataset.freeShip, 10) || 0;

    const money = (c) => '€' + (c / 100).toFixed(2).replace('.', ',');
    const moneyFor = (id) => {
      const el = document.querySelector(`.variant-option[data-variant-id="${id}"] .variant-price`);
      return el ? el.textContent.trim() : null;
    };

    function syncSticky(id) {
      chips.forEach((c) => {
        const on = c.dataset.variantId === String(id);
        c.classList.toggle('active', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      const p = moneyFor(id);
      if (priceEl && p) priceEl.textContent = p;
    }

    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        if (chip.disabled) return;
        const main = document.querySelector(`.variant-option[data-variant-id="${chip.dataset.variantId}"]`);
        if (main) main.click();
      });
      chip.addEventListener('mouseenter', () => {
        if (qInfo && chip.dataset.blurb) { qInfo.textContent = chip.dataset.blurb; qInfo.hidden = false; }
      });
      chip.addEventListener('mouseleave', () => { if (qInfo) qInfo.hidden = true; });
    });

    document.querySelectorAll('.variant-option').forEach((opt) => {
      opt.addEventListener('click', () => syncSticky(opt.dataset.variantId));
    });

    // Buy = Add auslösen (bleibt Add-Button → Mehrfachkauf möglich)
    if (buyBtn) {
      buyBtn.addEventListener('click', () => {
        const mainAdd = document.querySelector('[data-add-btn]');
        if (mainAdd) mainAdd.click();
      });
    }

    // Free-Shipping-Progress
    function renderShip(totalCents) {
      if (!shipWrap || threshold <= 0) return;
      shipWrap.hidden = false;
      if (shipFill) shipFill.style.width = Math.min((totalCents / threshold) * 100, 100) + '%';
      if (shipLabel) shipLabel.textContent = totalCents >= threshold
        ? '🎉 Gratisversand erreicht'
        : `Noch ${money(threshold - totalCents)} bis Gratisversand`;
    }

    async function refreshCart() {
      try {
        const cart = await (await fetch('/cart.js')).json();
        renderShip(cart.total_price);
        if (cartBadge) {
          cartBadge.textContent = cart.item_count;
          cartBadge.hidden = cart.item_count === 0;
        }
      } catch (e) {}
    }

    // Nach Add: Feedback + Cart/Ship aktualisieren
    document.addEventListener('onyx:cart-updated', () => {
      if (buyBtn) {
        buyBtn.classList.add('added');
        if (buyLabel) buyLabel.textContent = '✓ Hinzugefügt';
        setTimeout(() => {
          buyBtn.classList.remove('added');
          if (buyLabel) buyLabel.textContent = defLabel;
        }, 1500);
      }
      
      refreshCart();
    });
// Upsell: einmalig nach erstem Add zeigen
    const upsell = bar.querySelector('[data-scb-upsell]');
    if (upsell) {
      const addExtra = upsell.querySelector('[data-scb-upsell-add]');
      const skip = upsell.querySelector('[data-scb-upsell-skip]');

      document.addEventListener('onyx:cart-updated', () => {
        if (!upsell.dataset.shown && !sessionStorage.getItem('onyx_upsell_done')) {
          upsell.hidden = false;
          upsell.dataset.shown = '1';
          bar.classList.add('expanded');
        }
      });

      if (addExtra) addExtra.addEventListener('click', () => {
        const mainAdd = document.querySelector('[data-add-btn]');
        if (mainAdd) mainAdd.click();          // fügt aktuelle Variante nochmal hinzu
        upsell.hidden = true;
        sessionStorage.setItem('onyx_upsell_done', '1');
        bar.classList.remove('expanded');
      });

      if (skip) skip.addEventListener('click', () => {
        upsell.hidden = true;
        sessionStorage.setItem('onyx_upsell_done', '1');
        bar.classList.remove('expanded');
      });
    }
    refreshCart();
  }

  // Header/global Cart-Zähler (falls vorhanden)
  document.addEventListener('onyx:cart-updated', (e) => {
    const c = e.detail.count;
    const cc = document.getElementById('cart-count');
    const cb = document.getElementById('cart-badge');
    if (cc) cc.textContent = c;
    if (cb) { cb.textContent = c; cb.classList.toggle('show', c > 0); }
  });
})();




// ONYX – Age Gate (18+)
(function () {
  const gate = document.getElementById('age-gate');
  if (!gate) return;

  if (localStorage.getItem('onyx_age_ok')) {
    gate.classList.add('hidden');
    return;
  }
  document.body.style.overflow = 'hidden';

  document.getElementById('age-gate-yes').addEventListener('click', () => {
    localStorage.setItem('onyx_age_ok', '1');
    gate.classList.add('hidden');
    document.body.style.overflow = '';
  });
})();



// ONYX – Notfall-Overlay (Multi-Screen)
(function () {
  const btn = document.getElementById('emergency-btn');
  const overlay = document.getElementById('emergency-overlay');
  const closeBtn = document.getElementById('emergency-close');
  const bar = document.getElementById('sticky-cart-bar');
  if (!btn || !overlay) return;

  const screens = overlay.querySelectorAll('.em-screen');
  function show(n) {
    screens.forEach((s) => s.classList.toggle('active', s.dataset.screen === String(n)));
  }
  function open() {
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    show(1);
  }
  function close() {
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  btn.addEventListener('click', open);
  closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.classList.contains('active')) close();
  });

  overlay.querySelectorAll('[data-goto]').forEach((el) => {
    el.addEventListener('click', () => show(el.dataset.goto));
  });

  if (bar) {
    new MutationObserver(() => {
      document.body.classList.toggle('cart-bar-visible', bar.classList.contains('show'));
    }).observe(bar, { attributes: true, attributeFilter: ['class'] });
  }
})();